import { render } from "./appraisal-edit-model.vue?vue&type=template&id=8729b9e4"
import script from "./appraisal-edit-model.vue?vue&type=script&lang=js"
export * from "./appraisal-edit-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__